export default "__VITE_ASSET__BQlKBJiw__"